import { _SvBoletaPlantillaObtenerConfiguracion } from "../../../data/modulo/BoletaPlantilla";
import { ascending, group } from "d3-array";
import { DateV2 } from "../../../util/DateV2";
import { Entidad } from "../../../data/Entidad";
import { IBoletaConfiguracion } from "../../../data/entidad/Boleta";
import { UIUtilViewCalificacion } from "../Calificacion";
import IAlumno = Entidad.IAlumno;
import IAlumnoBoleta = UIUtilViewCalificacion.IAlumnoBoleta;
import IAlumnoBoletaFinal = UIUtilViewCalificacion.IAlumnoBoletaFinal;
import IElementoCalificado = UIUtilViewCalificacion.IElementoCalificado;
import IResLoadInfoToBuildReport = UIUtilViewCalificacion.IResLoadInfoToBuildReport;
import IAsignacionInfo = Entidad.IAsignacionInfo;
import ISubjectTeachersRel = UIUtilViewCalificacion.ISubjectTeachersRel;
import { _DICC_GRUPO } from "../../../data/modulo/Grupo";
import { _LOCALDATA_GetGruposHorariosDeAlumno } from "../../../data/modulo/Alumno";
import { _ModalConfirmacion } from "../../controlD3/ModalThings/ModalConfirmacion";
import _L from "../../../util/Labels";
import { GroupedCheckList } from "../../controlD3/GroupedCheckList";
import { DataModuloMain } from "../../../data/ModuloMain";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { FormGenerator, IField } from "../../controlD3/Formulario";
import { _DICC_ESCOLARIDAD } from "../../../data/modulo/Escolaridad";
import { _DICC_GRADO } from "../../../data/modulo/Grado";
import { SelectV2 } from "../../controlD3/SelectV2";
import { _ModalSimple } from "../../controlD3/ModalThings/ModalSimple";
import { _ModalForm } from "../../controlD3/ModalThings/ModalForm";
import { DataUtilAlertBot } from "../../../data/util/AlertBot";
import { MEscolaridad } from "../../../data/model/MEscolaridad";
import { MGrado } from "../../../data/model/MGrado";
import { MCicloEscolar } from "../../../data/model/MCicloEscolar";
import { ICicloEscolarPeriodo } from "../../../data/entidad/CicloEscolar";
import { MGrupo } from "../../../data/model/MGrupo";


interface IResLoadBoletasTemplateCfg {
    SuccessLoad: boolean
    MapBoletasPlantillaCfg?: Map<number, IBoletaConfiguracion>;
    ResultCode?: number;
}

interface IAlumnoBoletaInPeriodErr extends IAlumno {
    Period: ICicloEscolarPeriodo;
}

interface IAlumnoBoletasPeriodsErr extends IAlumno {
    Periods: ICicloEscolarPeriodo[];
}

interface IAlumnoErrPeriod extends IAlumno {
    PeriodsErr: number[];
}

// NOTE: Todos los alumnos deben pertencecer a la misma escuela, y nivel(escolaridad)
export async function _LoadBoletasTemplateCfg(students: IAlumno[]) {
    if (!students.length) return null;
    const resLoadBoletasTemplateCfg: IResLoadBoletasTemplateCfg = { SuccessLoad: true };
    let mapBoletasPlantillaCfgChild: Map<number, IBoletaConfiguracion> = new Map<number, IBoletaConfiguracion>();

    let studentsGradeGroupped = group(students, d => `${d.IdKinder}_${d.IdEscolaridad}_${d.IdGrado}`);
    for (const [_, arrStudents] of studentsGradeGroupped) {
        const { IdKinder, IdEscolaridad, IdGrado } = arrStudents[0];
        const resLoadBoletaTemplateCfg = await _SvBoletaPlantillaObtenerConfiguracion(IdKinder, IdEscolaridad, IdGrado)
        if (resLoadBoletaTemplateCfg.Resultado < 1) {
            resLoadBoletasTemplateCfg.SuccessLoad = false;
            resLoadBoletasTemplateCfg.ResultCode = resLoadBoletaTemplateCfg.Resultado;
            return resLoadBoletasTemplateCfg;
        }
        const { Datos } = resLoadBoletaTemplateCfg;
        arrStudents.forEach(d => mapBoletasPlantillaCfgChild.set(d.IdChild, Datos));
    }
    resLoadBoletasTemplateCfg.MapBoletasPlantillaCfg = mapBoletasPlantillaCfgChild;
    return resLoadBoletasTemplateCfg;
}

interface IResultBoletasData {
    resLoadBoletasTemplateCfg: IResLoadBoletasTemplateCfg;
    resLoadInfoToBuildGradesReport: IResLoadInfoToBuildReport;
}

export interface IBoletasProcessResult {
    boletasData: IAlumnoBoleta[];
    auxInfo: IAsignacionInfo[];
}

interface IProcessBoletasConfig {
    Students: IAlumno[];
    SchoolId: number;
    CicloEscolar: MCicloEscolar;
    SelectedPeriod?: ICicloEscolarPeriodo;
    PeriodsDtSelected?: Date[];
    RangeStartDate: string;
    RangeEndDate: string;
    FilterAbsencesCfg: { startRangeDate: Date, endRangeDate: Date };

    toggleProgress: (show: boolean) => void;
    getEvaluationsForStudent: (studentId: number) => IElementoCalificado[];
    onTemplateLoadError: (resultCode: number) => void;
    onReportInfoError: () => void;
    onBoletaAlreadyInPeriod: (studentsWithErrors: IAlumnoBoletaInPeriodErr[]) => void;
    onBoletaMissingPeriods: (studentsWithErrors: IAlumnoBoletasPeriodsErr[]) => void | Promise<void>;
    onPeriodsAfterWithBoleta: (studentsWithErrors: IAlumnoBoletasPeriodsErr[]) => void;
    onBoletasLimitExceeded: (studentsWithErrors: IAlumno[]) => void;
    onEvaluationIdRepeatError: (errors: IAlumnoErrPeriod[]) => void;
    onProcessingComplete: (result: IBoletasProcessResult) => void;
};

interface ICicloEscolarPeriodoOrdered extends ICicloEscolarPeriodo {
    Order: number;
};

export async function _ProccessAndValidateBoletasData(config: IProcessBoletasConfig) {
    const { SchoolId, CicloEscolar, RangeStartDate, RangeEndDate, PeriodsDtSelected, FilterAbsencesCfg } = config
    // const periodsOrdered = _GetPeriodsListFromCicloEscolar(CicloEscolar.Id, "asc").map<ICicloEscolarPeriodoOrdered>((d, i) => ({ ...d, Order: i + 1 }));
    // const periodsMap: Map<number, ICicloEscolarPeriodoOrdered> = new Map(periodsOrdered.map(periodo => [periodo.Id, periodo]));

    config.toggleProgress(true);
    let resLoadBoletasTemplateCfg = await _LoadBoletasTemplateCfg(config.Students)
    config.toggleProgress(false);

    if (!resLoadBoletasTemplateCfg.SuccessLoad) {
        config.onTemplateLoadError(resLoadBoletasTemplateCfg.ResultCode);
        return;
    }

    config.toggleProgress(true);
    const studentsIds = config.Students.map(d => d.IdChild);

    const resLoadInfoToBuildGradesReport = await UIUtilViewCalificacion._LoadInfoToBuildReport(
        studentsIds,
        SchoolId,
        CicloEscolar.Id,
        RangeStartDate,
        RangeEndDate
    );
    config.toggleProgress(false);

    if (!resLoadInfoToBuildGradesReport.successReload) {
        config.onReportInfoError();
        return;
    }

    const boletasAlumnos: IAlumnoBoleta[] = [];
    const arrPeriodsIdsEvalRepeat: IAlumnoErrPeriod[] = [];
    const periodBoletaAlreadyExist: IAlumnoBoletaInPeriodErr[] = [];
    const periodsBoletasMissing: IAlumnoBoletasPeriodsErr[] = [];
    const periodsBoletasAfter: IAlumnoBoletasPeriodsErr[] = [];
    const periodsBoletasBoundLimit: IAlumno[] = [];

    for (const student of config.Students) {
        const { IdChild } = student;
        let boletasInfoChild = resLoadInfoToBuildGradesReport.mapBoletasInfoChild.get(IdChild);
        const otherInfo = resLoadInfoToBuildGradesReport.mapOtherInfo.get(IdChild);

        let inasitenciasCount: number | null = null;
        if (otherInfo?.Inasistencias?.length) {
            const inasistenciasFiltered = UIUtilViewCalificacion._FilterInasistenciasByRanges(
                [...otherInfo.Inasistencias],
                PeriodsDtSelected,
                SchoolId,
                (!FilterAbsencesCfg ? null : { dtInitRange: new DateV2(FilterAbsencesCfg.startRangeDate), dtFinRange: new DateV2(FilterAbsencesCfg.endRangeDate) })
            )
            /* const inasistenciasFiltered = UIUtilViewCalificacion._FilterAbsencesInPeriodsRange(
                [...otherInfo.Inasistencias],
                [config.SelectedPeriod],
                {
                    dtInitRange: config.FilterAbsencesCfg?.startRangeDate,
                    dtEndRange: config.FilterAbsencesCfg?.endRangeDate,
                }
            ); */
            inasitenciasCount = inasistenciasFiltered.length;
        }

        const calificaciones = config.getEvaluationsForStudent(IdChild);

        // const currentPeriodPosition = periodsMap.get(config.SelectedPeriod.Id).Order;
        if (boletasInfoChild) {
            /* boletasInfoChild = boletasInfoChild.filter(d => periodsMap.get(d.IdPeriodo));
            boletasInfoChild.sort((a, b) => periodsMap.get(a.IdPeriodo).Order - periodsMap.get(b.IdPeriodo).Order);
            const periodsAfter = periodsOrdered.filter(d => d.Order > currentPeriodPosition);
            let periodsAfterWithBoleta = periodsAfter.filter(d => boletasInfoChild.find(boleta => boleta.IdPeriodo == d.Id));
            if (boletasInfoChild.find(boleta => boleta.IdPeriodo == config.SelectedPeriod.Id)) {
                periodBoletaAlreadyExist.push({ ...student, Period: config.SelectedPeriod })
            }
            if (periodsAfterWithBoleta.length) {
                periodsBoletasAfter.push({ ...student, Periods: periodsAfterWithBoleta })
            } */
            if (boletasInfoChild && boletasInfoChild.length > 2) { periodsBoletasBoundLimit.push(student); }

        }

        // const periodsBefore = periodsOrdered.filter(d => d.Order < currentPeriodPosition);
        // let periodsBeforeMissingBoleta = periodsBefore.filter(d => !(boletasInfoChild || []).find(boleta => boleta.IdPeriodo == d.Id));
        // if (periodsBeforeMissingBoleta.length) {
        //     periodsBoletasMissing.push({ ...student, Periods: periodsBeforeMissingBoleta })
        // }

        const currentPeriodEvalIds: number[] = [];
        calificaciones.forEach(d => {
            currentPeriodEvalIds.push(...d.IdsEvaluaciones);
        })

        if (boletasInfoChild) {
            boletasInfoChild.sort((a, b) => ascending(a.FechaCreacion, b.FechaCreacion));
            boletasInfoChild.forEach((boleta, iPos) => {
                const hasIdEvalRepeat = boleta.IdsEvaluaciones.some(idEval => currentPeriodEvalIds.some(currenPIdEval => currenPIdEval == idEval))
                if (hasIdEvalRepeat) {
                    let alumnoInfoErr = arrPeriodsIdsEvalRepeat.find(d => d.IdChild == student.IdChild);
                    if (!alumnoInfoErr) arrPeriodsIdsEvalRepeat.push({ ...student, PeriodsErr: [] });
                    alumnoInfoErr = arrPeriodsIdsEvalRepeat.find(d => d.IdChild == student.IdChild);
                    alumnoInfoErr.PeriodsErr.push(iPos + 1);
                }
            })
        }


        boletasAlumnos.push({
            Alumno: student,
            Evaluaciones: calificaciones,
            CicloEscolar: CicloEscolar,
            Comentario: "",
            InfoExtra: resLoadInfoToBuildGradesReport.mapInfoExtra.get(IdChild),
            BoletasGeneradasEnCiclo: boletasInfoChild || [],
            BoletaTemplateCfg: resLoadBoletasTemplateCfg.MapBoletasPlantillaCfg.get(IdChild),
            Inasistencias: inasitenciasCount,
        })
    }

    if (periodsBoletasBoundLimit.length && config.onBoletasLimitExceeded) {
        config.onBoletasLimitExceeded(periodsBoletasBoundLimit);
        return;
    }

    if (periodBoletaAlreadyExist.length && config.onBoletaAlreadyInPeriod) {
        config.onBoletaAlreadyInPeriod(periodBoletaAlreadyExist);
        return;
    }

    if (periodsBoletasAfter.length && config.onPeriodsAfterWithBoleta) {
        config.onPeriodsAfterWithBoleta(periodsBoletasAfter);
        return;
    }

    if (periodsBoletasMissing.length && config.onBoletaMissingPeriods) {
        await config.onBoletaMissingPeriods(periodsBoletasMissing);
    }


    if (arrPeriodsIdsEvalRepeat.length && config.onEvaluationIdRepeatError) {
        config.onEvaluationIdRepeatError(arrPeriodsIdsEvalRepeat);
        return;
    }

    config.onProcessingComplete({
        boletasData: boletasAlumnos,
        auxInfo: resLoadInfoToBuildGradesReport.arrAsignacionInfo
    });
}

export function _IsCurrentCicloEscolar(cicloEsc: MCicloEscolar) {
    const nowTime = new Date().getTime();
    return new Date(cicloEsc.FechaInicio).getTime() <= nowTime && new Date(cicloEsc.FechaFin).getTime() >= nowTime;
}

export function _GetBoletaNiveles(idsGroups: number[], context: IAlumnoBoletaFinal) {
    const groups = _GetBoletaGroups(idsGroups, context);
    const LevelIds = new Set<number>(groups.map(d => d.IdEscolaridad));
    const levels: MEscolaridad[] = [];
    for (const LevelId of LevelIds) {
        const level = GetEntityFromDic<MEscolaridad>(LevelId, _DICC_ESCOLARIDAD, 'Nivel', context);
        if (!level) {
            continue;
        }
        levels.push(level);
    }
    return levels;
}

export function _GetBoletaGrados(idsGroups: number[], context: IAlumnoBoletaFinal) {
    const groups = _GetBoletaGroups(idsGroups, context);
    const GradeIds = new Set<number>(groups.map(d => d.IdNivel));
    const grades: MGrado[] = [];
    for (const GradeId of GradeIds) {
        const grade = GetEntityFromDic(GradeId, _DICC_GRADO, 'Grado', context);
        if (!grade) {
            continue;
        }
        grades.push(grade);
    }
    return grades;
}

export function _GetBoletaGroups(idsGroups: number[], context: IAlumnoBoletaFinal): MGrupo[] {
    const groups = idsGroups.map<MGrupo>(idGroup => {
        const group = GetEntityFromDic(idGroup, _DICC_GRUPO, 'Grupo', context);
        if (!group) {
            console.warn("-d", `Nivel: ${idGroup} no encontrado para generacion de boleta`);
        }
        return group || null;
    });

    return groups.filter(d => !!d);
}

export function _GetBoletaGroupsName(idsGroups: number[]) {
    return idsGroups.map<string>(idGroup => {
        const group = _DICC_GRUPO.get(idGroup);
        return group?.Nombre || '';
    })
}

export function _GetStudentGroupsName(idAlumno: number) {
    return Array.from(_LOCALDATA_GetGruposHorariosDeAlumno(idAlumno).values())
        .filter(d => d.EsPrincipal)
        .map(d => d.Nombre);
}

export function _ReportCardInfoEdition(boletaInfo: IAlumnoBoletaFinal, onAccept: (changedTeachersRel?: boolean) => void) {
    const { ComentariosTeachers = "", ComentariosTutores = "", NombreTutores = "", BoletaTemplateCfg, CicloEscolar, CurrentGroupsIds, FinalGroupsIds } = boletaInfo;
    const UseBoletaV4 = BoletaTemplateCfg.IdPlantilla == 2;
    const UseMateriasMaestros = BoletaTemplateCfg.Extras && BoletaTemplateCfg.Extras.usaMateriaMaestro;
    const IsCurrentCicloEscolar = _IsCurrentCicloEscolar(CicloEscolar);

    let inputTeacherCurrentComment: HTMLTextAreaElement;
    let inputTutorCurrentComment: HTMLTextAreaElement;
    let inputTutorCurentNames: HTMLTextAreaElement;
    let tblSubjectTeachers: GroupedCheckList;
    let inputInasistencias: HTMLInputElement;

    let escolaridadInfoForm: FormGenerator<IEscolaridadInfo>;

    _ModalConfirmacion({
        Title: UseBoletaV4 ? _L("boleta_v4.title_edit") : IsCurrentCicloEscolar ? _L("boleta_v3.title_edit") : _L("boleta_v3.title_general_edition"),
        Width: UseBoletaV4 ? 520 : 280,
        VerifyOnAcceptRes: true,
        DrawContent: (content, mt) => {
            mt.Modal._EnableEnterKey(false);
            content.classed(UseBoletaV4 ? "edit_bolcal_v4" : "edit_bolcal_v3", true);

            if (!IsCurrentCicloEscolar) {
                const escolaridadInfoFormContainer = content.append("div").classed("form_container section", true);
                escolaridadInfoFormContainer.append("label").text(_L("calificacion.tag_escolaridad"));
                escolaridadInfoFormContainer.append("i").classed("escolaridad-warn", true).text(_L("calificacion.warn_generacion_boleta_ciclo_previo"));
                escolaridadInfoForm = GetEscolaridadInfoForm(boletaInfo);
                escolaridadInfoFormContainer.append(() => escolaridadInfoForm._Form.node());
                escolaridadInfoForm._GetIsValidForm();
            }

            if (!UseBoletaV4) {
                content.classed("form_modalbase", true);
                let absencesSectionContainer = content.append("div").classed("absences_count", true).classed("section", true);
                const currentAbsences = absencesSectionContainer.append("div").classed("period_absences", true).classed("section_item_info", true);
                currentAbsences.append("label").text(`${_L("boleta_v3.absences_in_period")} ${boletaInfo.CurrentPeriodPos + 1}:`);
                inputInasistencias = currentAbsences.append("div")
                    .classed("form_row", true)
                    .append("input")
                    .classed("inasistencias", true)
                    .attr("type", "number")
                    .attr("min", 0)
                    .attr("autocomplete", "off").node();
                inputInasistencias.value = boletaInfo.Inasistencias + '';
                return;
            }

            if (UseMateriasMaestros) {
                let subjectTeachersRel = boletaInfo.SubjectTeachersRel;
                let subjectTeachersContainer = content.append("div")
                    .classed("subject_teachers section", true);
                subjectTeachersContainer.append("label")
                    .text(_L("boleta_v4.subject_teachers"));
                tblSubjectTeachers = new GroupedCheckList({
                    Parent: subjectTeachersContainer.node(),
                    Data: subjectTeachersRel.map(d => ({
                        ValueMember: d.SubjectId,
                        DisplayMember: DataModuloMain._GetDataValueFieldByName("MateriaV2", d.SubjectId, "Nombre"),
                        GroupedList: d.TeachersInSubject.map(dGrouped => ({ ValueMember: dGrouped.Id, Checked: dGrouped.Abled, DisplayMember: dGrouped.NombreCompleto }))
                    })),
                })
            }

            // ***** TEACHERS SECTION *****
            let teachersRemarksContainer = content.append("div")
                .classed("teachers_comment", true)
                .classed("section", true);
            teachersRemarksContainer.append("label").text(_L("boleta_v4.teachers_remarks"));
            const currentPeriodTeachersContainer = teachersRemarksContainer.append("div")
                .classed("period_remark_teacher", true)
                .classed("section_item_info", true);
            currentPeriodTeachersContainer.append("label")
                .text(`${_L("boleta_v4.trimestre")} ${boletaInfo.CurrentPeriodPos + 1}:`);
            inputTeacherCurrentComment = currentPeriodTeachersContainer.append("textarea").classed("input-form", true).node();
            // ***** TUTORES SECTION *****
            let contenTutoresRemarks = content.append("div").classed("tutors_comment", true).classed("section", true);
            contenTutoresRemarks.append("label").text(_L("boleta_v4.tag_tutors_comments"));
            // ***** [#Trimestre] *****
            const currentPeriodTutorCont = contenTutoresRemarks.append("div").classed("period_tutores", true).classed("section_item_info", true);
            currentPeriodTutorCont.append("label").text(`${_L("boleta_v4.trimestre")} ${boletaInfo.CurrentPeriodPos + 1}:`);
            // ***** Comentario *****
            const currentPeriodTutors = currentPeriodTutorCont.append("div").classed("period_remark_tutor", true).classed("subsection_item_info", true);
            currentPeriodTutors.append("label").text(`${_L("boleta_v4.comment")}:`);
            inputTutorCurrentComment = currentPeriodTutors.append("textarea").classed("input-form", true).node();
            // ***** NombreTutores *****
            const tutoresNameCont = currentPeriodTutorCont.append("div").classed("tutores_name", true).classed("subsection_item_info", true);
            tutoresNameCont.append("label").text(_L("boleta_v4.tag_tutors_names") + ":");
            inputTutorCurentNames = tutoresNameCont.append("textarea").classed("input-form", true).node();

            inputTeacherCurrentComment.value = ComentariosTeachers;
            inputTutorCurrentComment.value = ComentariosTutores;
            inputTutorCurentNames.value = NombreTutores;
        },
        OnAccept: () => {
            if (!IsCurrentCicloEscolar) {
                if (!escolaridadInfoForm._GetIsValidForm()) {
                    NotificacionV2._Mostrar("Verificar información de escolaridad", "ADVERTENCIA");
                    return false;
                }
            }

            if (!UseBoletaV4) {
                if (Number(inputInasistencias.value) < 0) {
                    NotificacionV2._Mostrar(_L("calificacion.inasistencias_invalid"), "ADVERTENCIA");
                    return;
                }
                if (!IsCurrentCicloEscolar) boletaInfo.FinalGroupsIds = escolaridadInfoForm._GetModelValue("IdGrupos");
                boletaInfo.Inasistencias = Number(inputInasistencias.value);
                onAccept();
                return;
            }

            const EvalSubjectTeachersRelChangeV2 = (
                subjTeachersRelOrigin: UIUtilViewCalificacion.ISubjectTeachersRel[],
                subjTeachersRelFormTbl: UIUtilViewCalificacion.ISubjectTeachersRel[]
            ): boolean => {
                if (subjTeachersRelFormTbl.length != subjTeachersRelOrigin.length) return true;

                const toTeacherMap = (teachers: UIUtilViewCalificacion.ITeacherInSubject[]) =>
                    new Map(teachers.map(({ Id, Abled }) => [Id, Abled]));

                const hasTeacherChanges = (origin: UIUtilViewCalificacion.ITeacherInSubject[], updated: UIUtilViewCalificacion.ITeacherInSubject[]) => {
                    if (origin.length !== updated.length) return true;
                    const updatedMap = toTeacherMap(updated);
                    return origin.some(({ Id, Abled }) => updatedMap.get(Id) !== Abled);
                }

                const updatedMap = new Map(subjTeachersRelFormTbl.map(({ SubjectId, TeachersInSubject }) => [SubjectId, TeachersInSubject]));

                return subjTeachersRelOrigin.some(({ SubjectId, TeachersInSubject: TeachersInSubjectOrigin }) => {
                    const updatedTeachers = updatedMap.get(SubjectId);
                    return !updatedTeachers || hasTeacherChanges(TeachersInSubjectOrigin, updatedTeachers);
                });
            }

            boletaInfo.ComentariosTeachers = inputTeacherCurrentComment.value;
            boletaInfo.ComentariosTutores = inputTutorCurrentComment.value;
            boletaInfo.NombreTutores = inputTutorCurentNames.value;
            if (!IsCurrentCicloEscolar) boletaInfo.FinalGroupsIds = escolaridadInfoForm._GetModelValue("IdGrupos");

            if (!UseMateriasMaestros) {
                onAccept(true);
                return;
            }

            let boletaSubjectTeachersRel = tblSubjectTeachers.getDataList().map<UIUtilViewCalificacion.ISubjectTeachersRel>(d => ({
                SubjectId: d.ValueMember,
                SubjectName: d.DisplayMember,
                TeachersInSubject: d.GroupedList.map(teachers => ({ Id: teachers.ValueMember, NombreCompleto: teachers.DisplayMember, Abled: teachers.Checked })),
            }));

            let tblSubjTeachersChanged = EvalSubjectTeachersRelChangeV2(boletaInfo.SubjectTeachersRel, boletaSubjectTeachersRel);
            if (!tblSubjTeachersChanged) {
                onAccept();
                return;
            }
            boletaInfo.SubjectTeachersRel = tblSubjectTeachers.getDataList().map(d => ({
                SubjectId: d.ValueMember,
                SubjectName: d.DisplayMember,
                TeachersInSubject: d.GroupedList.map(teachers => ({ Id: teachers.ValueMember, NombreCompleto: teachers.DisplayMember, Abled: teachers.Checked }))
            }));
            onAccept(true);
        }
    })
}

export function _ModalEditionBoletaV4(boletaInfo: IAlumnoBoletaFinal, onAccept: (changedTeachersRel?: boolean) => void) {
    const { ComentariosTeachers = '', ComentariosTutores = '', NombreTutores = '' } = boletaInfo;

    let inputTeacherCurrentComment: HTMLTextAreaElement;
    let inputTutorCurrentComment: HTMLTextAreaElement;
    let inputTutorCurentNames: HTMLTextAreaElement;

    let tblSubjectTeachers: GroupedCheckList;
    let escolaridadInfoForm: FormGenerator<IEscolaridadInfo>;

    _ModalConfirmacion({
        Title: _L("boleta_v4.title_edit"),
        Width: 520,
        VerifyOnAcceptRes: true,
        DrawContent: (content, mt) => {
            mt.Modal._EnableEnterKey(false);
            content.classed("edit_bolcal_v4", true);
            // Añadir formulario de confirmación de Escolaridad

            escolaridadInfoForm = DrawEscolaridadInfoConfirmForm(boletaInfo, content);
            tblSubjectTeachers = DrawSubjectTeachersRelTable(boletaInfo, content);

            let teachersRemarksContainer = content.append("div")
                .classed("teachers_comment", true)
                .classed("section", true);
            teachersRemarksContainer.append("label").text(_L("boleta_v4.teachers_remarks"));
            const currentPeriodTeachersContainer = teachersRemarksContainer.append("div")
                .classed("period_remark_teacher", true)
                .classed("section_item_info", true);
            currentPeriodTeachersContainer.append("label")
                .text(`${_L("boleta_v4.trimestre")} ${boletaInfo.CurrentPeriodPos + 1}:`);
            inputTeacherCurrentComment = currentPeriodTeachersContainer.append("textarea").classed("input-form", true).node();
            // ***** TUTORES SECTION *****
            let contenTutoresRemarks = content.append("div").classed("tutors_comment", true).classed("section", true);
            contenTutoresRemarks.append("label").text(_L("boleta_v4.tag_tutors_comments"));
            // ***** [#Trimestre] *****
            const currentPeriodTutorCont = contenTutoresRemarks.append("div").classed("period_tutores", true).classed("section_item_info", true);
            currentPeriodTutorCont.append("label").text(`${_L("boleta_v4.trimestre")} ${boletaInfo.CurrentPeriodPos + 1}:`);
            // ***** Comentario *****
            const currentPeriodTutors = currentPeriodTutorCont.append("div").classed("period_remark_tutor", true).classed("subsection_item_info", true);
            currentPeriodTutors.append("label").text(`${_L("boleta_v4.comment")}:`);
            inputTutorCurrentComment = currentPeriodTutors.append("textarea").classed("input-form", true).node();
            // ***** NombreTutores *****
            const tutoresNameCont = currentPeriodTutorCont.append("div").classed("tutores_name", true).classed("subsection_item_info", true);
            tutoresNameCont.append("label").text(_L("boleta_v4.tag_tutors_names") + ":");
            inputTutorCurentNames = tutoresNameCont.append("textarea").classed("input-form", true).node();

            inputTeacherCurrentComment.value = ComentariosTeachers;
            inputTutorCurrentComment.value = ComentariosTutores;
            inputTutorCurentNames.value = NombreTutores;
        },
        OnAccept: () => {
            if (escolaridadInfoForm !== null && !escolaridadInfoForm._GetIsValidForm()) {
                NotificacionV2._Mostrar(_L("calificacion.warn_scholar_info_verify"), "ADVERTENCIA");
                return false;
            }

            boletaInfo.ComentariosTeachers = inputTeacherCurrentComment.value;
            boletaInfo.ComentariosTutores = inputTutorCurrentComment.value;
            boletaInfo.NombreTutores = inputTutorCurentNames.value;

            if (escolaridadInfoForm !== null) boletaInfo.FinalGroupsIds = escolaridadInfoForm._GetModelValue("IdGrupos");
            if (tblSubjectTeachers === null) { onAccept(true); return; }

            let boletaSubjectTeachersRel = tblSubjectTeachers.getDataList().map<UIUtilViewCalificacion.ISubjectTeachersRel>(d => ({
                SubjectId: d.ValueMember,
                SubjectName: d.DisplayMember,
                TeachersInSubject: d.GroupedList.map(teachers => ({ Id: teachers.ValueMember, NombreCompleto: teachers.DisplayMember, Abled: teachers.Checked })),
            }))

            let tblSubjTeachersChanged = EvalSubjectTeachersRelChangeV2(boletaInfo.SubjectTeachersRel, boletaSubjectTeachersRel);
            if (!tblSubjTeachersChanged) {
                onAccept();
                return;
            }
            boletaInfo.SubjectTeachersRel = tblSubjectTeachers.getDataList().map(d => ({
                SubjectId: d.ValueMember,
                SubjectName: d.DisplayMember,
                TeachersInSubject: d.GroupedList.map(teachers => ({ Id: teachers.ValueMember, NombreCompleto: teachers.DisplayMember, Abled: teachers.Checked }))
            }));
            onAccept(true);
        }
    })
}

export function _ModalEditionBoletaV4_1(boletaInfo: IAlumnoBoletaFinal, onAccept: (changedTeachersRel?: boolean) => void) {
    let tblSubjectTeachers: GroupedCheckList;
    let escolaridadInfoForm: FormGenerator<IEscolaridadInfo>;

    _ModalConfirmacion({
        Title: _L("boleta_v4.title_edit"),
        Width: 520,
        VerifyOnAcceptRes: true,
        DrawContent: (content, mt) => {
            mt.Modal._EnableEnterKey(false);
            content.classed("edit_bolcal_v4", true);

            escolaridadInfoForm = DrawEscolaridadInfoConfirmForm(boletaInfo, content);
            tblSubjectTeachers = DrawSubjectTeachersRelTable(boletaInfo, content);
        },
        OnAccept: () => {
            if (escolaridadInfoForm !== null && !escolaridadInfoForm._GetIsValidForm()) {
                NotificacionV2._Mostrar(_L("calificacion.warn_scholar_info_verify"), "ADVERTENCIA");
                return false;
            }

            if (escolaridadInfoForm !== null) boletaInfo.FinalGroupsIds = escolaridadInfoForm._GetModelValue("IdGrupos");
            if (tblSubjectTeachers == null) { onAccept(true); return; }

            let boletaSubjectTeachersRel = tblSubjectTeachers.getDataList().map<UIUtilViewCalificacion.ISubjectTeachersRel>(d => ({
                SubjectId: d.ValueMember,
                SubjectName: d.DisplayMember,
                TeachersInSubject: d.GroupedList.map(teachers => ({ Id: teachers.ValueMember, NombreCompleto: teachers.DisplayMember, Abled: teachers.Checked })),
            }))
            let tblSubjTeachersChanged = EvalSubjectTeachersRelChangeV2(boletaInfo.SubjectTeachersRel, boletaSubjectTeachersRel);

            if (!tblSubjTeachersChanged) {
                onAccept();
                return;
            }
            boletaInfo.SubjectTeachersRel = tblSubjectTeachers.getDataList().map(d => ({
                SubjectId: d.ValueMember,
                SubjectName: d.DisplayMember,
                TeachersInSubject: d.GroupedList.map(teachers => ({ Id: teachers.ValueMember, NombreCompleto: teachers.DisplayMember, Abled: teachers.Checked }))
            }));
            onAccept(true);
        }
    })
}

export function _ModalEditionBoletaV3(boletaInfo: IAlumnoBoletaFinal, onAccept: () => void) {
    const { CicloEscolar } = boletaInfo;
    const IsCurrentCicloEscolar = _IsCurrentCicloEscolar(CicloEscolar);

    let inputInasistencias: HTMLInputElement;
    let escolaridadInfoForm: FormGenerator<IEscolaridadInfo>;

    _ModalConfirmacion({
        Title: IsCurrentCicloEscolar ? _L("boleta_v3.title_edit") : _L("boleta_v3.title_general_edition"),
        Width: 280,
        VerifyOnAcceptRes: true,
        DrawContent: (content, mt) => {
            mt.Modal._EnableEnterKey(false);
            content.classed("edit_bolcal_v3", true);
            content.classed("form_modalbase", true);
            escolaridadInfoForm = DrawEscolaridadInfoConfirmForm(boletaInfo, content);

            let absencesSectionContainer = content.append("div").classed("absences_count", true).classed("section", true);
            const currentAbsences = absencesSectionContainer.append("div").classed("period_absences", true).classed("section_item_info", true);
            currentAbsences.append("label").text(`${_L("boleta_v3.absences_in_period")} ${boletaInfo.CurrentPeriodPos + 1}:`);
            inputInasistencias = currentAbsences.append("div")
                .classed("form_row", true)
                .append("input")
                .classed("inasistencias", true)
                .attr("type", "number")
                .attr("min", 0)
                .attr("autocomplete", "off").node();
            inputInasistencias.value = boletaInfo.Inasistencias + '';
        },
        OnAccept: () => {
            if (escolaridadInfoForm !== null && escolaridadInfoForm._GetIsValidForm()) {
                NotificacionV2._Mostrar(_L("calificacion.warn_scholar_info_verify"), "ADVERTENCIA");
                return false;
            }

            if (Number(inputInasistencias.value) < 0) {
                NotificacionV2._Mostrar(_L("calificacion.inasistencias_invalid"), "ADVERTENCIA");
                return;
            }
            if (escolaridadInfoForm !== null) boletaInfo.FinalGroupsIds = escolaridadInfoForm._GetModelValue("IdGrupos");
            boletaInfo.Inasistencias = Number(inputInasistencias.value);
            onAccept();
            return;
        }
    })
}

function DrawEscolaridadInfoConfirmForm(boletaInfo: IAlumnoBoletaFinal, modalContainer: TSelectionHTML<"div">) {
    const { CicloEscolar } = boletaInfo;
    const IsCurrentCicloEscolar = _IsCurrentCicloEscolar(CicloEscolar);

    if (IsCurrentCicloEscolar) return null;

    let escolaridadInfoForm: FormGenerator<IEscolaridadInfo>;
    const escolaridadInfoFormContainer = modalContainer.append("div").classed("form_container section", true);
    escolaridadInfoFormContainer.append("label").text(_L("calificacion.tag_escolaridad"));
    escolaridadInfoFormContainer.append("i").classed("escolaridad-warn", true).text(_L("calificacion.warn_generacion_boleta_ciclo_previo"));
    escolaridadInfoForm = GetEscolaridadInfoForm(boletaInfo);
    escolaridadInfoFormContainer.append(() => escolaridadInfoForm._Form.node());
    escolaridadInfoForm._GetIsValidForm();

    return escolaridadInfoForm;
}

function DrawSubjectTeachersRelTable(boletaInfo: IAlumnoBoletaFinal, modalContainer: TSelectionHTML<"div">) {
    const { BoletaTemplateCfg } = boletaInfo;
    const vermateriamaestroHeader = (
        BoletaTemplateCfg.Extras?.usaMateriaMaestroInformacionCabecera == null
            ? BoletaTemplateCfg.Extras.usaMateriaMaestro
            : BoletaTemplateCfg.Extras.usaMateriaMaestroInformacionCabecera
    );

    const vermateriamaestroSubjectsSigns = (
        BoletaTemplateCfg.Extras?.usaMateriaMaestroAsignaturasFirmas == null
            ? vermateriamaestroHeader
            : BoletaTemplateCfg.Extras.usaMateriaMaestroAsignaturasFirmas
    );
    const UseMateriasMaestros = vermateriamaestroHeader || vermateriamaestroSubjectsSigns;
    if (!UseMateriasMaestros) return null;

    let subjectTeachersRel = boletaInfo.SubjectTeachersRel;
    let subjectTeachersContainer = modalContainer.append("div")
        .classed("subject_teachers section", true);
    subjectTeachersContainer.append("label")
        .text(_L("boleta_v4.subject_teachers"));
    return new GroupedCheckList({
        Parent: subjectTeachersContainer.node(),
        Data: subjectTeachersRel.map(d => ({
            ValueMember: d.SubjectId,
            DisplayMember: DataModuloMain._GetDataValueFieldByName("MateriaV2", d.SubjectId, "Nombre"),
            GroupedList: d.TeachersInSubject.map(dGrouped => ({ ValueMember: dGrouped.Id, Checked: dGrouped.Abled, DisplayMember: dGrouped.NombreCompleto }))
        })),
    })
}

function EvalSubjectTeachersRelChangeV2(subjTeachersRelOrigin: ISubjectTeachersRel[], subjTeachersRelFormTbl: ISubjectTeachersRel[]) {
    if (subjTeachersRelFormTbl.length != subjTeachersRelOrigin.length) return true;

    const toTeacherMap = (teachers: UIUtilViewCalificacion.ITeacherInSubject[]) =>
        new Map(teachers.map(({ Id, Abled }) => [Id, Abled]));

    const hasTeacherChanges = (origin: UIUtilViewCalificacion.ITeacherInSubject[], updated: UIUtilViewCalificacion.ITeacherInSubject[]) => {
        if (origin.length !== updated.length) return true;
        const updatedMap = toTeacherMap(updated);
        return origin.some(({ Id, Abled }) => updatedMap.get(Id) !== Abled);
    }

    const updatedMap = new Map(subjTeachersRelFormTbl.map(({ SubjectId, TeachersInSubject }) => [SubjectId, TeachersInSubject]));

    return subjTeachersRelOrigin.some(({ SubjectId, TeachersInSubject: TeachersInSubjectOrigin }) => {
        const updatedTeachers = updatedMap.get(SubjectId);
        return !updatedTeachers || hasTeacherChanges(TeachersInSubjectOrigin, updatedTeachers);
    });
}
interface IEscolaridadInfo {
    IdNivel: number;
    IdGrado: number;
    IdGrupos: number[];
}

function GetEscolaridadInfoForm(context: IAlumnoBoletaFinal) {
    let { CurrentGroupsIds, FinalGroupsIds } = context;
    const form = new FormGenerator<IEscolaridadInfo>();

    const GetFilteredGrades = (GroupsIds: number[] = CurrentGroupsIds) => {
        const idLevel = form._GetModelValue("IdNivel");
        if (idLevel == null) {
            return [];
        }
        return _GetBoletaGrados(GroupsIds, context).filter(d => d.IdEscolaridad == idLevel);
    }

    const GetFilteredGroups = (GroupsIds: number[] = CurrentGroupsIds) => {
        const idGrade = form._GetModelValue("IdGrado");
        if (idGrade == null) {
            return [];
        }
        return _GetBoletaGroups(GroupsIds, context).filter(d => d.IdNivel == idGrade);
    }

    const schemaEscolaridadInfo: IField<IEscolaridadInfo>[] = [
        {
            model: "IdNivel",
            labelText: _L("general.nivel"),
            type: "selectMaterial",
            selectMaterialAttr: {
                Data: () => _GetBoletaNiveles(CurrentGroupsIds, context),
                onChange: () => {
                    const gradeCombo = form._ControlsData.get("IdGrado").instance as SelectV2;
                    gradeCombo._RefreshList();
                    const groupsCombo = form._ControlsData.get("IdGrupos").instance as SelectV2;
                    groupsCombo._RefreshList();
                },
                required: true,
                valueMember: "Id",
                displayMember: "Nombre",
                multiselect: false,
            },
        },
        {
            model: "IdGrado",
            labelText: _L("general.grado"),
            type: "selectMaterial",
            selectMaterialAttr: {
                Data: () => GetFilteredGrades(),
                required: true,
                valueMember: "IdNivel",
                displayMember: "Nombre",
                multiselect: false,
            }
        },
        {
            model: "IdGrupos",
            labelText: _L("general.grupo"),
            type: "selectMaterial",
            selectMaterialAttr: {
                Data: () => GetFilteredGroups(),
                multiselect: true,
                required: true,
                valueMember: "IdGrupo",
                displayMember: "Nombre",
            }
        }
    ]

    form._Crear({
        LabelMaxWidth: 150,
        schema: schemaEscolaridadInfo,
        onValideForm: (dataForm) => {
            return true;
        },
    });
    (() => {
        if (FinalGroupsIds?.length) return;
        const currentLevels = _GetBoletaNiveles(CurrentGroupsIds, context)
        if (!currentLevels?.length || currentLevels.length > 1) return;
        const [currentLevel] = currentLevels;
        const currentGrades = _GetBoletaFilteredGrades(CurrentGroupsIds, currentLevel.Id, context);
        if (!currentGrades?.length || currentGrades.length > 1) return;
        FinalGroupsIds = CurrentGroupsIds;
    })();

    if (FinalGroupsIds?.length) {
        form._SetModelValue("IdNivel", _GetBoletaNiveles(FinalGroupsIds, context)[0]?.Id || null);
        (form._GetModelControl("IdGrado").instance as SelectV2)._RefreshList();
        form._SetModelValue("IdGrado", GetFilteredGrades(FinalGroupsIds)[0]?.IdNivel || null);
        (form._GetModelControl("IdGrupos").instance as SelectV2)._RefreshList();
        form._SetModelValue("IdGrupos", GetFilteredGroups(FinalGroupsIds).map(d => d.IdGrupo) || []);
    }

    return form;
}

export function _GetBoletaFilteredGrades(GroupsIds: number[], idLevel: number, context: IAlumnoBoletaFinal) {
    if (idLevel == null) {
        return [];
    }
    return _GetBoletaGrados(GroupsIds, context).filter(d => d.IdEscolaridad == idLevel);
}

export function _GetBoletaFilteredGroups(GroupsIds: number[], idGrade: number, context: IAlumnoBoletaFinal) {
    if (idGrade == null) {
        return [];
    }
    return _GetBoletaGroups(GroupsIds, context).filter(d => d.IdNivel == idGrade);
}

function GetEntityFromDic<T>(
    id: number,
    dic: Map<number, T>,
    entityName: string,
    context?: IAlumnoBoletaFinal
): T | null {
    const entity = dic.get(id);
    if (entity != null) return entity;

    if (context != null) {
        const warnTitle = `${entityName} con ID ${id} no encontrado para generacion de boleta`;
        console.warn("-d", warnTitle);
        const warnMessagge = `
            \nAlumno: ${context.Alumno.NombreCompleto} - ID: ${context.Alumno.IdChild}
            \nCicloEscolar: ${context.CicloEscolar.Nombre} - ID: ${context.CicloEscolar.Id}
            \nGruposEnBoleta: [${context.CurrentGroupsIds.join(", ")}]
        `;
        DataUtilAlertBot._SendWarn(warnTitle, warnMessagge);
    }
    return null;
}